<!-- <a (click)="deleteUserFromGroupRole()">
<mat-icon aria-hidden="false" aria-label="icon">{{icon_delete}}</mat-icon>
</a> -->
@if (isUserDisplayed) {
  <a >
    <!-- <mat-checkbox
    [checked]="isUserChecked()"
    (change)="onUserCheckedChange($event)"
    aria-label="Auswählen"
    style="margin-right:8px;">
  </mat-checkbox> -->
  <!-- <input type="checkbox" [checked]="isUserInGroupRole" (change)="isUserInGroupRole = $event.target.checked" /> -->
  <input style="margin-left: 6px" type="checkbox" [checked]="isUserInGroupRole" (change)="changeCheckbox($event.target)"
    />
    <!-- <span [style.color]="isUserInGroupRole ? 'red' : 'inherit'" style="margin-left:6px">Benutzer</span> -->
    <!-- <button mat-raised-button class="btn btn-squirrel pull-left"
    style="margin-top: -3px; margin-left: 0px"
    matTooltip="Benutzer aus Rolle entfernen"
    (click)="deleteUserFromGroupRole()">
    Löschen
  </button> -->
</a>
}
